// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';

import {alertService} from '../../../services/AlertService';

import TableCard from "../../../components/tablecard/TableCard";
import ModalForm from "../../../components/modal/form/ModalForm";

import {bankSelector, getBank, insertBank, updateBank} from './bankSlice';

import {Colors} from "../../../assets/Colors";
import {maxPageGlobal} from "../../../assets/config";

const BankPage = ({}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [firstLoading, setFirstLoading] = useState(false);
    const [start, setStart] = useState(0);
    const [count, setCount] = useState(maxPageGlobal);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(0);
    const [search, setSearch] = useState('');
    const [searchFetch, setSearchFetch] = useState(false);
    const [insertFetch, setInsertFetch] = useState(false);
    const [updateFetch, setUpdateFetch] = useState(false);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [currentData, setCurrentData] = useState({});

    const bank = useSelector(
        bankSelector
    );

    useEffect(() => {
        dispatch(getBank({
            start: start,
            count: count,
            search: '',
        }));
    }, []);

    useEffect(() => {

        if ((search !== '') && bank.isGetSuccess && !bank.isGetFetching) {
            let calc = bank?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = bank.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        } else if ((search === '') && bank.isGetSuccess && !bank.isGetFetching) {
            let calc = bank?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = bank.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        }

        if (!bank?.isGetFetching && bank.isGetSuccess && (maxPage === 0) && (firstLoading === false)) {
            let calc = bank?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = bank.data ? Math.ceil(calc / count) : 1;
            setMaxPage(tempMaxPage);
            setFirstLoading(true);
            dispatch(getBank({
                start: start,
                count: count,
                search: search,
            }));
        }

        if (
            (insertFetch)
        ) {
            setInsertFetch(false);
            if (bank.isGetSuccess) {
                alertService.success(bank.message, {autoClose: true, keepAfterRouteChange: false});
                dispatch(getBank({
                    start: start,
                    count: count,
                    search: search,
                }));
            }
        }

        if (
            (updateFetch)
        ) {
            setUpdateFetch(false);
            if (bank.isUpdateSuccess) {
                alertService.success(bank.message, {autoClose: true, keepAfterRouteChange: false});
                dispatch(updateBank({
                    start: start,
                    count: count,
                    search: search,
                }));
            }
        }

    });

    // function handleGetBank(params) {
    //   return dispatch(getBank(params));
    // }

    function handleInsertBank(param) {
        setInsertFetch(true);
        const params = {
            namaBank: param.inputOneValue,
            bankID: param.dropdownOneValue,
        };
        dispatch(insertBank(params));
    }

    function handleUpdateBank(param) {
        setUpdateFetch(true);

        const params = {
            namaBank: param.inputOneValue,
            idBank: currentData.BankID,
            status: param.status,
        };
        dispatch(updateBank(params));
    }

    function handleSearch(searchValue) {
        let params = {
            start: 0,
            count: 5,
            search: searchValue,
        }
        dispatch(getBank(params));

        setStart(0);
        setCount(5);
        setSearch(searchValue);
        setSearchFetch(true);
    }

    function handleUpdatePage(newPage) {
        let newStart = (newPage * count) - count;

        let params = {
            start: newStart,
            count: count,
            search: search,
        }
        dispatch(getBank(params));

        setPage(newPage)
        setStart(newStart)
    }

    function handleUpdateCount(newCount) {
        let calc = (bank.count - 1);
        if (calc === 0) {
            calc = 1;
        }

        let params = {
            start: (newCount === "-1") ? 0 : start,
            count: (newCount === "-1") ? bank.count : newCount,
            search: search,
        }
        dispatch(getBank(params));

        setPage(1);
        setCount((newCount === "-1") ? bank.count : newCount)
        setStart((newCount === "-1") ? 0 : start);
        setMaxPage((newCount === "-1") ? 1 : Math.ceil(calc / newCount))
    }

    function handleCurrentData(values) {
        setCurrentData(values);
    }

    function handleModal(status) {
        setShowModalAdd(status.showModalAdd);
        setShowModalEdit(status.showModalEdit);
    }

    if (!firstLoading) {
        return <div>loading</div>
    } else {
        return (

            <div className="md:ml-64">
                <div style={{background: Colors.primary}} className="pt-14 pb-16 px-3 md:px-8 h-auto">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                    </div>
                </div>

                <div className="px-3 md:px-8 h-auto -mt-32">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 px-4">
                            <TableCard
                                backButton={true}
                                backUrl={"master"}
                                handleSearch={handleSearch}
                                searchPlaceholder="Bank"
                                updatePage={handleUpdatePage}
                                updateCount={handleUpdateCount}
                                currentData={handleCurrentData}
                                currentPage={page}
                                maxPage={maxPage}
                                tableTitle="Master Bank"
                                tableData={bank.data}
                                colOneTitle="ID"
                                colOneData="BankID"
                                colTwoTitle="Nama Bank"
                                colTwoData="NamaBank"
                                status="Status"

                                fetching={bank.isGetFetching}
                                modal={handleModal}
                                editEnabled={true}

                            />
                        </div>
                    </div>
                </div>
                {showModalAdd &&
                    <ModalForm
                        showModal={showModalAdd}
                        addEnabled={true}
                        modal={handleModal}
                        modalTitle="Tambah Bank"
                        inputOneTitle="Nama Bank"
                        inputOnePlaceholder=""
                        submitButtonTitle="Submit"
                        handleSubmit={handleInsertBank}
                    />
                }
                {showModalEdit &&
                    <ModalForm
                        showModal={showModalEdit}
                        editEnabled={true}
                        id={currentData.BankID}
                        modal={handleModal}
                        modalTitle="Ubah Bank"
                        inputOneTitle="Nama Bank"
                        inputOneValue={currentData.NamaBank}
                        status={currentData.Status}
                        submitButtonTitle="Submit"
                        handleSubmit={handleUpdateBank}
                    />
                }
            </div>

        )
    }

}


export default BankPage;